import { v1 as uuidv1 } from 'uuid';
import { ANSWER_DEFAULT } from 'containers/QuestionnairePage/constants';
import { getPromptFromHtml } from '../../../../components/FormattedInput/helpers';

export const getEmptyAnswer = (valid = false) => ({
  body: '',
  refId: uuidv1(),
  type: ANSWER_DEFAULT,
  isEmptyAnswer: !valid,
});

export const defaultAnswersSelector = (answers) =>
  answers.filter((answer) => answer.type === ANSWER_DEFAULT);

export const emptyAnswersSelector = (answers) =>
  answers.filter((answer) => answer.isEmptyAnswer);

export const isAnswerEmpty = (answer) =>
  getPromptFromHtml(answer.body) === '' && !(answer.media && answer.media.url);
